import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';

const BottomBar = () => {
  const currentYear = new Date().getFullYear(); // Automatically fetch the current year

  return (
    <AppBar
      position="fixed"
      sx={{
        top: 'auto',
        bottom: 0,
        background: 'linear-gradient(to top, #121212, #1d1d1d)', // Fading background
        zIndex: 1300,
        height: '7vh', // Bottom bar takes up 20% of the screen height
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'left', alignItems: 'left', height: '100%' }}> {/* Centering content */}
        {/* Left side with Year */}
        <Typography variant="caption" sx={{ color: '#fff', fontSize: '0.75rem' }}>
          &copy; {currentYear} mogio services ltd
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default BottomBar;
